import React from 'react'
import System from 'src/helper/system';

const GuestPopupActionButton = (props) => {
    const { data, SetStatus } = props;

    return (
        <>
            <div className="avnet-modal modal-530">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal" onClick={(() => SetStatus(false))}>×</button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">{data.title}</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body py-0">
                        <div className="clearfix" />

                        <div className='mb-3 text-center mt-4 mb-5'>
                            {data.body}
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" onClick={(() => SetStatus(false))}>
                            {data.closeButton}
                            </button>
                            <button className="bs5 btn btn-primary btn-sm w145" onClick={() => window.location.href = System.getLoginPageUrl()}>{data.yesButton}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GuestPopupActionButton